export const designPersonalizationContextIdSelector = (state: State.GlobalState): string | undefined =>
  state.designPersonalization.designPersonalizationContextId

export const dpcsLoadingSelector = (state: State.GlobalState): boolean => state.designPersonalization.dpcsLoading

export const hasImageSelector = (state: State.GlobalState): boolean => !!state.designPersonalization.designPersonalizationWidgetHasImage
